export const BANK_SETTINGS = {
  BANNER: "BANNER",
  MAINTENANCE_MODE: "MAINTENANCE_MODE",
  FEATURE_AXIA_NETWORK_TOKEN: "FEATURE_AXIA_NETWORK_TOKEN",
  DEFAULT_STAKING_SPENDING_LIMIT: "DEFAULT_STAKING_SPENDING_LIMIT",
  WIRE_DEPOSIT_INFO: "WIRE_DEPOSIT_INFO"
};
